import { render, staticRenderFns } from "./Certificacion2.vue?vue&type=template&id=94eb5fc6&scoped=true"
import script from "./Certificacion2.vue?vue&type=script&lang=js"
export * from "./Certificacion2.vue?vue&type=script&lang=js"
import style0 from "./Certificacion2.vue?vue&type=style&index=0&id=94eb5fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94eb5fc6",
  null
  
)

export default component.exports